<template>
  <div class="grid grid-cols-12 gap-4">
    <div class="col-span-12">
      <div class="grid grid-cols-12 gap-4 py-1 border-b-2 border-gray-200">
        <div class="col-span-12">
          <div class="grid grid-cols-12 gap-4 mt-1">
            <div class="col-span-12">
              <span class="bg-gray text-white px-2 py-1 rounded-sm text-xs"
                    :class="(entityType === 'CORPORATE') ? 'bg-primary' : 'bg-orange'">#{{ entityType.toLowerCase() }}</span>
            </div>
          </div>
        </div>
        <div class="col-span-12" v-if="entityType === 'CORPORATE'">
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12">
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus"
                  id="companyName"
                  disabled="true"
                  :value="person.registeredName"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus"
                  id="companyName"
                  disabled="true"
                  :value="person.brn"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus"
                  id="companyName"
                  disabled="true"
                  :value="person.primaryEmail"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus"
                  id="companyName"
                  disabled="true"
                  :value="person.primaryPhone"
                  required>
                </input>
              </div>
            </div>
            <div class="col-span-12">
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus"
                  id="companyName"
                  disabled="true"
                  :value="person.dateOfIncorporation"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus"
                  id="companyName"
                  disabled="true"
                  :value="person.subType ? cleanEntityType(person.subType) : ''"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus"
                  id="companyName"
                  disabled="true"
                  :value="person.countryOfOrigin"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus"
                  id="companyName"
                  disabled="true"
                  :value="person.addressInCountryOfIncorporation"
                  required>
                </input>
              </div>
            </div>
            <div class="col-span-12">
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus"
                  rows="4"
                  disabled="true"
                  :value="person.postalAddress"
                  required>
                </input>
              </div>
            </div>
          </div>
        </div>
        <div class="col-span-12" v-if="entityType === 'INDIVIDUAL'">
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12">
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus"
                  id="companyName"
                  disabled="true"
                  :value="person.givenName"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" v-if="person.middleName" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus"
                  id="companyName"
                  disabled="true"
                  :value="person.middleName"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus"
                  id="companyName"
                  disabled="true"
                  :value="person.surName"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus text-capitalize"
                  id="companyName"
                  disabled="true"
                  :value="person.idType?.toLowerCase() || ''"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus"
                  id="companyName"
                  disabled="true"
                  :value="person.idNumber"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus"
                  id="companyName"
                  disabled="true"
                  :value="person.nationality"
                  required>
                </input>
              </div>
            </div>
            <div class="col-span-12">
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus"
                  id="companyName"
                  disabled="true"
                  :value="person.email"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus"
                  id="companyName"
                  disabled="true"
                  :value="person.phoneNumber"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" v-if="person.sex" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus text-capitalize"
                  id="companyName"
                  disabled="true"
                  :value="person.sex.toLowerCase()"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus"
                  id="companyName"
                  disabled="true"
                  :value="person.dateOfBirth ? dateFormat(person.dateOfBirth) : ''"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus"
                  id="companyName"
                  disabled="true"
                  :value="person.occupation"
                  required>
                </input>
              </div>
            </div>
            <div class="col-span-12">
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus"
                  disabled="true"
                  :value="person.physicalAddress?.district?.name || ''"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus"
                  disabled="true"
                  :value="person.physicalAddress?.region?.name || ''"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus"
                  disabled="true"
                  :value="person.physicalAddress?.subcounty?.name || ''"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus"
                  disabled="true"
                  :value="person.physicalAddress?.parish?.name || ''"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus"
                  disabled="true"
                  :value="person.physicalAddress?.village?.name || ''"
                  required>
                </input>
              </div>
            </div>
            <div class="col-span-12">
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus"
                  id="companyName"
                  disabled="true"
                  :value="person.postalAddress"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus"
                  id="companyName"
                  disabled="true"
                  :value="person.street"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
                  type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent form-text text-sm noFocus"
                  id="companyName"
                  disabled="true"
                  :value="person.plotNumber"
                  required>
                </input>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { dateFormat } from "@/commons/composables/utilities";

interface Person {
  registeredName?: string
  brn?: string
  primaryEmail?: string
  primaryPhone?: string
  dateOfIncorporation?: string
  subType?: string
  countryOfOrigin?: string
  addressInCountryOfIncorporation?: string
  postalAddress?: string
  givenName?: string
  middleName?: string
  surName?: string
  idType?: string
  idNumber?: string
  nationality?: string
  email?: string
  phoneNumber?: string
  sex?: string
  dateOfBirth?: string
  occupation?: string
  physicalAddress?: {
    district: { name: string }
    region: { name: string }
    subcounty: { name: string }
    parish: { name: string }
    village: { name: string }
  }
  street?: string
  plotNumber?: string
}

interface Props {
  person: Person
  entityType: string
}

defineProps<Props>()

const cleanEntityType = (name: string) => {
  let n = name.replaceAll("-", " ")
  return n.charAt(0).toUpperCase() + n.slice(1)
}
</script>
